import { createContext, useContext, useEffect, useState } from "react";
import { useProtectedAxiosInstance } from "../hooks/axiosInstance";
import { useNotificationContext } from "./notificationContext";
import errorResolver from "../utils/error-resolver";
import { AccessSectionListRequest } from "../services/Endpoints/access-section/accessSectionEndpoint";
import { useAuthContext } from "./authContext";

export interface IProfileContext {
  accessSections?: string[];
  setAccessSections?: (payload: string[]) => void;
}

const roleAccessContext = createContext<IProfileContext>({
  accessSections: [],
  setAccessSections: (payload: string[]) => false,
});

export function RoleAccessContextProvider({
  accessSections,
  setAccessSections,
  ...props
}: any) {
  const { token, logout } = useAuthContext();

  const protectedInstance = useProtectedAxiosInstance();
  const { setNotification } = useNotificationContext();

  const getData = async () => {
    const accessSectionRequest = new AccessSectionListRequest(
      protectedInstance
    );

    try {
      const {
        data: { access_sections },
      } = await accessSectionRequest.send();
      setAccessSections(access_sections.map((itm) => itm.key));
    } catch (error: any) {
      const resp = errorResolver({ error, setNotification });
      if (resp == "unauthorized") {
        logout();
      }
    }
  };
  useEffect(() => {
    getData();
  }, [token]);

  return (
    <roleAccessContext.Provider
      value={{
        accessSections,
      }}
      {...props}
    />
  );
}

export const useRoleAccessContext = () => useContext(roleAccessContext);
